/* The person's own pages (ADR-0212): sections as cards under the header card. Tokens only. */

.stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  padding: 4px;
}

.section {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--panel);
  min-width: 0;
}

.head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--line);
}

.title {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
  font-weight: 600;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  min-width: 0;
}

/* A label track and a value track of fixed shape (alignment audit, 2026-11-03). The row was a flex
   line with the value pushed right, so each control began wherever its own width put it; now every
   label starts on one line and every control starts on one line, whatever the control is. */
.row {
  display: grid;
  grid-template-columns: minmax(10rem, 16rem) minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-height: 28px;
}

.label {
  color: var(--ink);
  font-size: var(--t-body);
}

.value {
  display: flex;
  flex-wrap: wrap;
  justify-self: start;
  align-items: center;
  gap: 8px;
  color: var(--muted);
  font-size: var(--t-body);
}

@media (max-width: 560px) {
  .row {
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }
}
